import './buttonSpinner.css';

const ButtonSpinner = ({ size }: { size: number }) => {
    return (
        <div className="buttonSpinner" style={{ width: `${size}px`, height: `${size}px` }}></div>
    );
};

export default ButtonSpinner;
